import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FilterListIcon from '@mui/icons-material/FilterList';
import './Menu.scss';

const _Menu = ({items, onClick, selected}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={'flex-aligned-justified-center'}>
            <FilterListIcon onClick={handleClick}
                            style={{color: '#6E6C6C'}}
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
            />
            <Menu
                id="basic-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom', // Aligns the menu to open below the icon
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top', // Ensures the menu is positioned properly
                    horizontal: 'left',
                }}
            >
                {Object.entries(items).map(([key, value], index) => (
                    <MenuItem className={value === selected ? 'menu-item-selected' : ''} key={index} onClick={() => {
                        onClick(key);
                        handleClose();
                    }}>{value}</MenuItem>
                ))}
            </Menu>
        </div>
    );
};
export default _Menu;
